// extracted by mini-css-extract-plugin
module.exports = {"icon":"_41Ebc","right":"-c9As","left":"Z9odk","up":"tJ2q0","down":"umVaO","sm":"ta9hK","m":"IulMi","lg":"Wfefe","xl":"NO8m2"};